import { TooltipConfig } from './tooltip.config';

export const tooltipDefaultConfig: TooltipConfig = {
  position: 'right',
  delay: 300,
  backgroundColor: 'bg-black',
  textColor: 'text-white'
}
